module.exports = __webpack_public_path__ + "static/Michael-9120139498eec15ed9abc44eb7a38051.jpeg";